import logger from 'apps/website/themes/inline_editor/logger';

type MessageType = {
  type: string;
  payload?: any;
};

const dispatchMessage = (message: MessageType) => {
  const targetOrigin = window.Kajabi?.themeBuilder?.appOrigin;
  if (!targetOrigin) {
    logger.error('Unable to dispatch message. Target origin is not set');
    return;
  }

  const { type } = message || {};
  if (!type) {
    logger.error('Unable to dispatch message. Message type is not set');
    return;
  }

  window.parent.postMessage(message, targetOrigin);
  logger.info(`Dispatched message: ${type}`, message);
};
export default dispatchMessage;
